const developmentEnv = {
  CLINIC_API_URL: "http://localhost:8090",
  DIGITAL_URL: ".spdata-staging.com.br/appointment",
  CORE_API_URL: "http://localhost:8090",
  AUTH_API_URL: "http://localhost:8090",
  AUTH_API_CLIENT: "pacient",
  AUTH_API_SECRET: "secret"
};

const builtEnv = {
  CLINIC_API_URL: "https://api.spdataminhaclinica.com.br",
  DIGITAL_URL: ".spdata.com.br",
  CORE_API_URL: "https://api.spdataminhaclinica.com.br",
  AUTH_API_URL: "https://api.spdataminhaclinica.com.br",
  AUTH_API_CLIENT: "pacient",
  AUTH_API_SECRET: "secret"
};

export const env =
  process.env.NODE_ENV === "development" ? developmentEnv : builtEnv;
